import { combineReducers } from 'redux';
import { companiesAndCompaniesAccountsReducer } from './company-account/company-account.state';

const companyReducer = combineReducers({
    companiesAndCompaniesAccounts: companiesAndCompaniesAccountsReducer,
});

export default companyReducer;
